import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../../hooks/http.hook";

export const fetchNavAdditionalMenu = createAsyncThunk(
  "navAdditionalMenu/fetchNavAdditionalMenu",
  async () => {
    const { request } = useHttp();
    const dataLang = localStorage.getItem("dataLang");
    const shortNameParam = dataLang
      ? `?lang=${JSON.parse(dataLang).shortName}`
      : "";
    const { json } = await request(
      `api/getMenu/additional/${window.env.PROJECT_ID}${shortNameParam}`,
      "GET"
    );
    return await new Promise((resolve) => resolve(json));
  }
);

export const extraReducers = (builder) => {
  builder
    .addCase(fetchNavAdditionalMenu.pending, (state) => {
      state.loadingStatus = "loading";
    })

    .addCase(fetchNavAdditionalMenu.fulfilled, (state, action) => {
      state.loadingStatus = "loaded";
      state.menu = action.payload.data.menu;
    })

    .addCase(fetchNavAdditionalMenu.rejected, (state) => {
      state.loadingStatus = "error";
    })
    .addDefaultCase(() => {});
};
